
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/settings/data-access",
      function () {
        return require("private-next-pages/settings/data-access.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/settings/data-access"])
      });
    }
  